import { useEffect } from "react";

import { parseLinkHeader } from "@/core/utils/pagination";
import { Store } from "@/core/data_sources/store";
import { useService } from "@/core/utils/hooks";

import { getSuperAdminTenants, type SuperAdminTenantsQuery } from "../services";
import { SuperAdminTenantsState } from "./state";

import type { SuperAdminTenantsActions } from "./actions";
import type { SuperAdminTenantsHooks } from "./hooks";

export class SuperAdminTenantsStore extends Store<
  SuperAdminTenantsState,
  SuperAdminTenantsActions,
  SuperAdminTenantsHooks
> {
  private static _instance: SuperAdminTenantsStore;

  static get instance() {
    SuperAdminTenantsStore._instance =
      SuperAdminTenantsStore._instance || new SuperAdminTenantsStore();
    return this._instance;
  }

  constructor() {
    super(
      new SuperAdminTenantsState(),
      {
        setTenants: (list) => {
          this.state.setTenants(list);
        },
        setCount: (count) => {
          this.state.setCount(count);
        },
      },
      {
        useTenantsStoreService: <Q extends SuperAdminTenantsQuery>(q: Q) => {
          const { data, error, loading, query, setQuery } = useService(
            getSuperAdminTenants,
            q,
          );
          useEffect(() => {
            if (error) {
              return;
            }
            if (!loading && data) {
              const pagination = parseLinkHeader(data.header);
              this.state.setTenants(data.data ?? []);
              this.state.setCount(pagination.count ?? data.data?.length ?? 0);
            }
          }, [loading, data, error]);
          return { data, error, loading, query, setQuery };
        },
      },
    );
  }
}
